import { render, staticRenderFns } from "./CountryForm.vue?vue&type=template&id=af159968&scoped=true&"
import script from "./CountryForm.vue?vue&type=script&lang=js&"
export * from "./CountryForm.vue?vue&type=script&lang=js&"
import style0 from "./CountryForm.vue?vue&type=style&index=0&id=af159968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af159968",
  null
  
)

export default component.exports